import React, {
  createContext,
  useMemo,
  useContext,
  FunctionComponent,
  PropsWithChildren,
} from 'react'

// TODO: add rest of offsets like right, bottom, left
export interface OffsetManagerValue {
  top: number
  sidebarWidth: number
  hiddenSidebarWidth: number
}

export const OffsetManagerContext = createContext<OffsetManagerValue>({
  top: 0,
  sidebarWidth: 0,
  hiddenSidebarWidth: 0,
})

export const useOffsetManagerContext = () => useContext(OffsetManagerContext)

type OffsetManagerProps = OffsetManagerValue & PropsWithChildren

export const OffsetManager: FunctionComponent<OffsetManagerProps> = ({
  top,
  sidebarWidth,
  hiddenSidebarWidth,
  children,
}) => {
  const value = useMemo(
    () => ({ top, sidebarWidth, hiddenSidebarWidth }),
    [top, sidebarWidth, hiddenSidebarWidth],
  )

  return (
    <OffsetManagerContext.Provider {...{ value }}>
      {children}
    </OffsetManagerContext.Provider>
  )
}
